import React from 'react';

import classes from './CheckoutSummary.css';
import Burger from '../../Burger/Burger';
import Button from '../../UI/Button/Button';

const checkoutSummary = (props) => (
  <div className={classes.CheckoutSummary}>
    <h1>This is your burger, Please Enjoy!</h1>
    <div style={{width: '100%', margin: 'auto'}}>
      <Burger ingredients={props.ingredients}/>
    </div>
    <Button
      btnType='Success'
      clicked={props.continue}>CONTINUE</Button>
    <Button 
      btnType='Danger'
      clicked={props.cancel}>CANCEL</Button>
  </div>
);

export default checkoutSummary;


// WEBPACK FOOTER //
// ./src/components/Order/CheckoutSummary/CheckoutSummary.js